import React from "react";
import { Link } from "react-router-dom";
export const PaginationComponent = (props: any) => {
  return (
    props.previousPage !== props.nextPage ? (
      <div className="blog-pagination">
        <nav>
          <ul className="pagination justify-content-center pagination-center">
            {props.links.map((link: any) => (
              link.label.includes('Previous') ? (
                <li key={link.label} className="page-item previtem">
                  <Link className="page-link" to={`?page=${props.previousPage}`}>
                    <i className="feather-chevron-left" />
                  </Link>
                </li>
              ) :
                (link.label.includes('Next') ? (
                  <li key={link.label} className="page-item nextlink">
                    <Link className="page-link" to={`?page=${props.nextPage}`}>
                      {" "}
                      <i className="feather-chevron-right" />
                    </Link>
                  </li>
                ) : (
                  <li key={link.label} className={`page-item ${link.active ? 'active' : ''}`}>
                    <Link className={`page-link ${link.active ? 'active' : ''}`} to={`?page=${link.label}`}>
                      {link.label}
                    </Link>
                  </li>
                )

                )))}
          </ul>
        </nav>
      </div>
    ) : ''

  );
}
